import { api } from '@/api/client'

export type AdminMenuNode = {
  id: number
  name: string
  icon: string | null
  path: string | null
  module_key: string | null
  children: AdminMenuNode[]
}

type MenuResponseBody = {
  data: {
    menu: AdminMenuNode[]
  }
}

/** GET /api/v1/admin/menu — tenant DB admin_menu_items ağacı */
export async function fetchAdminMenu(): Promise<AdminMenuNode[]> {
  const { data } = await api.get<MenuResponseBody>('/admin/menu')
  return data.data.menu
}
